let state = {
    barbwirePath: '',
    horizontalPath: '',
    pathList: [],
    hingeRingPath: '',
    hingering: false,
    cantilever_opening_direction: '',
    cantileverOpenDirection: true,
    gates: [],
    pipes: [
        {product_id: '138055G', name: '1-3/8 .055', color: 'Galvanized', diameter: "1-3/8", upright: 1},
        {product_id: '138055BK', name: '1-3/8 .055', color: 'Black', diameter: "1-3/8", upright: 1},
        {product_id: '138055BR', name: '1-3/8 .055', color: 'Brown', diameter: "1-3/8", upright: 1},
        {product_id: '138055GR', name: '1-3/8 .055', color: 'Green', diameter: "1-3/8", upright: 1},
        
        {product_id: '158055G', name: '1-5/8 .055', color: 'Galvanized', diameter: "1-5/8", upright: 1.25},
        {product_id: '158055BK', name: '1-5/8 .055', color: 'Black', diameter: "1-5/8", upright: 1.25},
        {product_id: '158055BR', name: '1-5/8 .055', color: 'Brown', diameter: "1-5/8", upright: 1.25},
        {product_id: '158055GR', name: '1-5/8 .055', color: 'Green', diameter: "1-5/8", upright: 1.25},
        {product_id: '158SS20G', name: '1-5/8 SS20', color: 'Galvanized', diameter: "1-5/8", upright: 1.25},
        {product_id: '158SS20BK', name: '1-5/8 SS20', color: 'Black', diameter: "1-5/8", upright: 1.25},
        {product_id: '158SS20BR', name: '1-5/8 SS20', color: 'Brown', diameter: "1-5/8", upright: 1.25},
        {product_id: '158SS20GR', name: '1-5/8 SS20', color: 'Green', diameter: "1-5/8", upright: 1.25},
        {product_id: '158SS40G', name: '1-5/8 SS40', color: 'Galvanized', diameter: "1-5/8", upright: 1.25},
        {product_id: '158SS40BK', name: '1-5/8 SS40', color: 'Black', diameter: "1-5/8", upright: 1.25},
        {product_id: '158SS40BR', name: '1-5/8 SS40', color: 'Brown', diameter: "1-5/8", upright: 1.25},
        {product_id: '158SS40GR', name: '1-5/8 SS40', color: 'Green', diameter: "1-5/8", upright: 1.25},
        
        {product_id: '178055G', name: '1-7/8 .055', color: 'Galvanized', diameter: "1-7/8", upright: 1.5},
        {product_id: '178055BK', name: '1-7/8 .055', color: 'Black', diameter: "1-7/8", upright: 1.5},
        {product_id: '178055BR', name: '1-7/8 .055', color: 'Brown', diameter: "1-7/8", upright: 1.5},
        {product_id: '178055GR', name: '1-7/8 .055', color: 'Green', diameter: "1-7/8", upright: 1.5},
        {product_id: '178SS20G', name: '1-7/8 SS20', color: 'Galvanized', diameter: "1-7/8", upright: 1.5},
        {product_id: '178SS20BK', name: '1-7/8 SS20', color: 'Black', diameter: "1-7/8", upright: 1.5},
        {product_id: '178SS20BR', name: '1-7/8 SS20', color: 'Brown', diameter: "1-7/8", upright: 1.5},
        {product_id: '178SS20GR', name: '1-7/8 SS20', color: 'Green', diameter: "1-7/8", upright: 1.5},
        {product_id: '178SS40G', name: '1-7/8 SS40', color: 'Galvanized', diameter: "1-7/8", upright: 1.5},
        {product_id: '178SS40BK', name: '1-7/8 SS40', color: 'Black', diameter: "1-7/8", upright: 1.5},
        {product_id: '178SS40BR', name: '1-7/8 SS40', color: 'Brown', diameter: "1-7/8", upright: 1.5},
        {product_id: '178SS40GR', name: '1-7/8 SS40', color: 'Green', diameter: "1-7/8", upright: 1.5},
        
        {product_id: '238SS40G', name: '2-3/8 SS40', color: 'Galvanized', diameter: "2-3/8", upright: 2},
        {product_id: '238SS40BK', name: '2-3/8 SS40', color: 'Black', diameter: "2-3/8", upright: 2},
        {product_id: '238SS40BR', name: '2-3/8 SS40', color: 'Brown', diameter: "2-3/8", upright: 2},
        {product_id: '238SS40GR', name: '2-3/8 SS40', color: 'Green', diameter: "2-3/8", upright: 2},

    ],

    customer: '',
    workorder: '',
    date: '',
    salesperson: '',
    gate_type: '',
    leaf: '',
    color: '',
    height: '',
    width: '',
    barbwire: false,
    pipe_set: false,
    outerVerticalPipe: '',
    outerVerticalPipeQty: 0,
    innerVerticalPipe: '',
    innerVerticalPipeQty: 0,
    outerHorizontalPipe: '',
    outerHorizontalPipeQty: 0,
    innerHorizontalPipe: '',
    innerHorizontalPipeQty: 0,
    counterBalancePipe: '',
    diaganolPipe: '',
    diaganolPipeQty: 0,
    chainlinkGauge: '',
    chainlinkSelvage: '',
    chainlinkColor: '',
    hingeType: '',
    latchType: '',
    auto_calculate_bracing: '',
    hingeRing: '',
    wdtT2T: false,
    htT2T: false,
    hardwareSet: false,
    chainlink: {},
    description: '',

    
}

export default state